import React from "react";
import { Layout, Menu } from "antd";
import {
    PictureOutlined,
    AppstoreOutlined,
    GifOutlined,
    DeleteOutlined,
} from "@ant-design/icons";

const { Sider } = Layout;

const SIDEBAR_ITEMS = [
    {
        key: "collection",
        icon: <AppstoreOutlined />,
        label: "Collection",
    },
    {
        key: "unsplash",
        icon: <PictureOutlined />,
        label: "Unsplash",
    },
    {
        key: "pexels",
        icon: <PictureOutlined />,
        label: "Pexels",
    },
    {
        key: "pixabay",
        icon: <PictureOutlined />,
        label: "Pixabay",
    },
    {
        key: "pixabay_png",
        icon: <PictureOutlined />,
        label: "Pixabay PNG",
    },
    {
        key: "gif",
        icon: <GifOutlined />,
        label: "GIF",
    },
    {
        key: "texture",
        icon: <PictureOutlined />,
        label: "Texture",
    },
    {
        key: "trash",
        icon: <DeleteOutlined />,
        label: "Trash",
    },
];

function Sidebar({ activeSource, onChange }) {
    return (
        <Sider
            width={220}
            style={{
                background: "#fff",
                borderRight: "1px solid #f0f0f0",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                marginRight: 15,
            }}
        >
            <Menu
                className="imagePickerMenu"
                mode="inline"
                selectedKeys={[activeSource]}
                onClick={({ key }) => onChange(key)}
                items={SIDEBAR_ITEMS}
                style={{
                    borderRight: 0,
                    flex: 1,
                    marginTop: 20, //fixed here
                }}
            />
        </Sider>
    );
}
export default Sidebar;
